import i18n from '@/i18n'

/**
 * Formats a price amount in euros to a string.
 * If the price is an integer, it returns it without decimal places.
 * If the price is decimal, it returns it with two decimal places.
 * It uses the current language for formatting (e.g. comma for French).
 *
 * @param amountInEuros Amount in euros
 * @returns Formatted price string
 */
export const formatPrice = (amountInEuros: number): string => {
  const language = i18n.language || 'fr'

  // If the amount is an integer, we don't show decimal places
  // If it's decimal, we show 2 decimal places as requested
  const isInteger = Math.abs(amountInEuros % 1) < 0.001
  const minimumFractionDigits = isInteger ? 0 : 2

  return new Intl.NumberFormat(language, {
    minimumFractionDigits,
    maximumFractionDigits: 2,
  }).format(amountInEuros)
}

/**
 * Formats a price amount in cents to a string in euros.
 *
 * @param amountInCents Amount in cents
 * @returns Formatted price string
 */
export const formatPriceFromCents = (amountInCents: number): string => {
  return formatPrice(amountInCents / 100)
}
